<section class="main-content">
  <h1>Error</h1>
  <mat-card class="error-card" >
      <p>The application has encountered the following critical error:</p>
    <br>
      <p class="red" data-type="text-error-message">{{errorMessage}}</p>
    </mat-card>
</section>

